export default {
      id: "circle__lost-connection-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__lost-connection",
      toString: function () {
        return this.url;
      }
    }